import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-12 md:py-16 lg:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-3">
            <i className="ri-bookmark-3-line"></i>
            <span>每日精选</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            精选漫画推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            编辑团队每日从韩漫、日漫、国漫中甄选优质作品，覆盖热血、恋爱、悬疑、玄幻等多元题材
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {cardsData.map((card) => (
            <div
              key={card.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="img-container aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const container = e.currentTarget.closest('.img-container');
                    if (container) container.classList.add('hidden');
                  }}
                />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-3 leading-relaxed">
                  {card.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-primary-600 text-xs font-medium">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}